// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

export const getData = createAsyncThunk('orders/getData', async params => {

    let data = []
    return {
        params,
        data: data
    }
})

/* istanbul ignore next  */
mock.onGet('/apps/dashboard/getTotalUsers').reply(config => {
    // eslint-disable-next-line object-curly-newline
    const responseDummy = {
        totalSales: 30200,
        totalPromoters: 200,
        totalSellers: 1200
    }

    return [
        200,
        {
            totalUsers: responseDummy
        }
    ]
})

export const getTotalUsers = createAsyncThunk('dashboard/getTotalUsers', async () => {
    const response = await axios.get('/apps/dashboard/getTotalUsers')
    return response.data.totalUsers

})


/* istanbul ignore next  */
mock.onGet('/apps/dashboard/getTotalForPromoters').reply(config => {
    // eslint-disable-next-line object-curly-newline
    const responseDummy = {
        myCommission: 30200,
        totalSellers: 200,
        discountLevel: 10
    }

    return [
        200,
        {
            totalForPromoters: responseDummy
        }
    ]
})

export const getTotalForPromoters = createAsyncThunk('dashboard/getTotalForPromoters', async () => {
    const response = await axios.get('/apps/dashboard/getTotalForPromoters')
    return response.data.totalForPromoters

})


/* istanbul ignore next  */
mock.onGet('/apps/dashboard/getDiscountLevels').reply(config => {
    // eslint-disable-next-line object-curly-newline
    const responseDummy = [
        {
            id: 1,
            week: "4a y 5a semana",
            percentage: 58.6
        },
        {
            id: 2,
            week: "3a semana",
            percentage: 58.6
        },
        {
            id: 3,
            week: "2a semana",
            percentage: 34.9
        },
        {
            id: 4,
            week: "1a semana",
            percentage: 5
        }
    ]

    return [
        200,
        {
            discountLevels: responseDummy
        }
    ]
})

export const getDiscountLevels = createAsyncThunk('dashboard/getDiscountLevels', async () => {
    const response = await axios.get('/apps/dashboard/getDiscountLevels')
    return response.data.discountLevels

})

/* istanbul ignore next  */
mock.onGet('/apps/dashboard/getSalesPerMonth').reply(config => {
    // eslint-disable-next-line object-curly-newline
    const responseDummy = {
        total: 13000,
        months: [
            {
                month: "Jan",
                total: 150
            },
            {
                month: "Feb",
                total: 200
            },
            {
                month: "Mar",
                total: 160
            },
            {
                month: "Apr",
                total: 220
            },
            {
                month: "May",
                total: 140
            },
            {
                month: "Jun",
                total: 320
            },
            {
                month: "July",
                total: 100
            },
            {
                month: "Aug",
                total: 270
            },
            {
                month: "Sep",
                total: 200
            },
            {
                month: "Oct",
                total: 340
            },
            {
                month: "Nov",
                total: 290
            },
            {
                month: "Dec",
                total: 320
            }
        ]
    }

    return [
        200,
        {
            salesPerMonth: responseDummy
        }
    ]
})

export const getSalesPerMonth = createAsyncThunk('dashboard/getSalesPerMonth', async () => {
    const response = await axios.get('/apps/dashboard/getSalesPerMonth')
    return response.data.salesPerMonth

})

/* istanbul ignore next  */
mock.onGet('/apps/dashboard/getPromoteStatistics').reply(config => {
    // eslint-disable-next-line object-curly-newline
    const responseDummy = [
        {
            id: 1,
            full_name: "Jorge Arturo Montaño García",
            promoterCode: 44331,
            sellerCode: 44331,
            avatar: "/static/media/1.6a7d13c0.png",
            sales: 12,
            lastPercentage: 68,
            down: true
        },
        {
            id: 2,
            full_name: "Jorge Arturo Montaño García",
            promoterCode: 44331,
            sellerCode: 44331,
            avatar: "",
            sales: 10,
            lastPercentage: 68,
            down: true
        },
        {
            id: 3,
            full_name: "Jorge Arturo Montaño García",
            promoterCode: 44331,
            sellerCode: 44331,
            avatar: "",
            sales: 13,
            lastPercentage: 10,
            down: false
        },
        {
            id: 4,
            full_name: "Jorge Arturo Montaño García",
            promoterCode: 44331,
            sellerCode: 44331,
            avatar: "",
            sales: 9,
            lastPercentage: 68,
            down: true
        },
        {
            id: 5,
            full_name: "Sara Elizabeth Moncada Díaz",
            promoterCode: 44331,
            sellerCode: 44331,
            avatar: "",
            sales: 17,
            lastPercentage: 30,
            down: false
        }
    ]

    return [
        200,
        {
            promoters: responseDummy
        }
    ]
})

export const getPromoteStatistics = createAsyncThunk('dashboard/getPromoteStatistics', async () => {
    const response = await axios.get('/apps/dashboard/getPromoteStatistics')
    return response.data.promoters

})


export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        params: {},
        data: [],
        total: 1,
        totalUsers: [],
        discountLevels: [],
        salesPerMonth: {},
        promoters: [],
        totalForPromoters: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.total
            })
            .addCase(getTotalUsers.fulfilled, (state, action) => {
                state.totalUsers = action.payload
            })
            .addCase(getDiscountLevels.fulfilled, (state, action) => {
                state.discountLevels = action.payload
            })
            .addCase(getSalesPerMonth.fulfilled, (state, action) => {
                state.salesPerMonth = action.payload
            })
            .addCase(getPromoteStatistics.fulfilled, (state, action) => {
                state.promoters = action.payload
            })
            .addCase(getTotalForPromoters.fulfilled, (state, action) => {
                state.totalForPromoters = action.payload
            })
    }
})

export default dashboardSlice.reducer
